export default "__VITE_ASSET__Ba52VcuQ__"